
import { Component, Vue, Watch } from "vue-property-decorator";
import { IUser, IPasswordData } from "@/../../server/src/user/IUser";
import { UserSvc } from "./UserSvc"
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import ButtonVue from "@/lib/Button.vue";


declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window { localStorage: any; }
}

@Component({
  components: { ButtonVue},
})
export default class UserLoginVue extends Vue {
  key: number = 0;
  key1: number= 0;
  credentials: IPasswordData = { idn: "", password: "" };
  passw1=""
  logged_in=false

  async get_logged_in() {
    return await bus.get_logged_in()
  }

  created() {
    console.log("******** USER LOGIN VUE created")
    this.credentials.idn = window.localStorage.getItem("last_used_username");

    bus.register("on_login", this.on_login);
    bus.register("on_logout", this.on_logout);
  }

  beforeDestroy() {  
      bus.remove("on_login", this.on_login);
      bus.remove("on_logout", this.on_logout);
  }  

  async mounted() {
    await this.refresh()
  }

  async login() {
      await bus.login(this.credentials)
  }

  async refresh() {
    this.logged_in = await this.get_logged_in()
    this.key++
    this.key1++
    console.log("******** USER LOGIN VUE refresh", this.key,this.logged_in )
  }

  async logout() {
    await bus.logout()
    this.credentials.password = "";
    await this.refresh()
  }

 async on_login(e: any) {
    const user = <IUser>e.detail;
    if (user) window.localStorage.setItem("last_used_username", user._id);
    (<any>this.$router).go()
    await this.refresh()
  }

  async on_logout(e: any) {
    console.log("******** USER LOGIN VUE refresh on_logout")
    await this.refresh()
  }
}
